<template>
  <component
    :is="linkTag"

    v-bind="linkProps"

    :class="linkClass"

    @click="onClick"
  >
    <module-icon
      v-if="icon && !iconNegative"

      :class="[
        `link__icon`,
        `link__icon--positive`,
      ]"

      :icon="icon"
    /><!--
    --><slot v-if="($slots.default || [])[0]" /><!--
    --><template v-else>{{ labelSet }}</template><!--
    --><module-icon
      v-if="icon && iconNegative"

      :class="[
        `link__icon`,
        `link__icon--negative`,
      ]"

      :icon="icon"
    />
  </component>
</template>

<script>
// Services
import { getLinkType, getLinkTag, createLinkProps } from 'services/link';

// Modules
import ModuleIcon from 'modules/Icon';

// Other
import VueScrollTo from 'vue-scrollto';

// Export
export default {
  name: `module-link`,

  // Components
  components: {
    ModuleIcon,
  },

  // Props
  props: {
    color: String,
    label: String,
    external: {
      type: Boolean,
      default: false,
    },
    link: [
      String,
      Object,
    ],
    title: String,
    icon: String,
    iconNegative: Boolean,
    noUnderline: Boolean,
  },

  // Data
  computed: {
    linkType() {
      return getLinkType(this.link);
    },
    linkTag() {
      return getLinkTag(this.link);
    },
    linkProps() {
      const options = {
        external: this.external || false,
      };
      return createLinkProps(this.link, this.labelSet, this.title, options);
    },
    labelSet() {
      if (this.$slots.default && (this.$slots.default || [])[0]) {
        return this.$slots.default[0].text;
      }
      return this.label || ``;
    },
    linkClass() {
      return [
        `link`,
        this.color && this.color !== `inherit` ? `link--${this.color}` : ``,
        {
          'link--anchor': this.linkType === `anchor`,
          'link--external': this.linkType === `a`,
          'link--internal': this.linkType === `router-link`,
          'link--no-underline': this.noUnderline,
          'link--icon': this.icon,
        },
      ];
    },
  },

  // Methods
  methods: {
    onClick(e) {
      if (this.linkType === `anchor`) {
        e.preventDefault();
        VueScrollTo.scrollTo(this.link, 500, {});
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Link.vue?bfaeb74c